import { ContentKind, Content } from '@shared/domain/content/content.aggregate';

export interface ContentDto {
  id: number;
  kind: ContentKind;
  name: string;
  nameLanguage: string;
  url: string;
  thumbnailUrl: string;
}

export const toContentDomainEntity = (
  incommingContent: ContentDto
): Content => {
  return {
    id: incommingContent.id,
    kind: incommingContent.kind,
    name: incommingContent.name,
    nameLanguage: incommingContent.nameLanguage,
    url: incommingContent.url,
    thumbnailUrl: incommingContent.thumbnailUrl
  };
};
